import React, { useRef } from "react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

function ToolCard({ name, hint, index }) {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - rect.left}px`);
    el.style.setProperty("--my", `${e.clientY - rect.top}px`);
  };
  return (
    <StaggerItem>
      <div
        ref={ref}
        onMouseMove={onMove}
        data-testid={`tool-card-${index}`}
        className="group relative h-full overflow-hidden rounded-3xl border border-[#293891]/10 bg-[#FFFFFF] p-8"
        style={{
          backgroundImage:
            "radial-gradient(220px circle at var(--mx, -100px) var(--my, -100px), rgba(59,130,246,0.18), transparent 65%)",
        }}
      >
        <div className="flex items-start justify-between">
          <span className="font-display text-3xl font-semibold tracking-tight text-[#293891]">{name}</span>
          <span className="font-display text-sm text-[#293891]/20">0{index + 1}</span>
        </div>
        <p className="mt-2 text-sm uppercase tracking-[0.18em] text-[#566076]">{hint}</p>
        <div className="mt-8 h-px w-full bg-[#293891]/[0.05]">
          <div className="h-px w-0 bg-[#e63329] transition-all duration-700 group-hover:w-full" />
        </div>
      </div>
    </StaggerItem>
  );
}

export default function Tools() {
  return (
    <section id="tools" data-testid="tools-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <Reveal>
              <Eyebrow>Tools You&apos;ll Master</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
                The industry-standard stack, end to end.
              </h2>
            </Reveal>
          </div>
        </div>

        <StaggerGroup className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {COURSE.tools.map((t, i) => (
            <ToolCard key={t.name} name={t.name} hint={t.hint} index={i} />
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
